import ReactDOM from 'react-dom/client';
import {Header} from './header';
import {Console} from './console';
import {Panels} from './panels';
import {Controller} from './controller';
import * as U from './util';
import './index.css';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <div className=" bg-gradient-to-b from-black to-gray-600 h-screen grid grid-cols-1 grid-rows-[auto_1fr_auto] overflow-hidden">
    <Header />
    {!Controller.noUI && (
      <>
        <Panels controller={Controller} />
        <Console logs={U.logs} />
      </>
    )}
  </div>
);
